import { render, staticRenderFns } from "./Topic.vue?vue&type=template&id=30ff23d8&scoped=true&"
import script from "./Topic.vue?vue&type=script&lang=js&"
export * from "./Topic.vue?vue&type=script&lang=js&"
import style0 from "./Topic.vue?vue&type=style&index=0&id=30ff23d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ff23d8",
  null
  
)

export default component.exports